module.exports = __webpack_public_path__ + "static/media/home-slider-1-slide-1b.6f0dd583.jpg";